<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati {{shema}}</h1>

      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
              <pridelovalec :pridelovalec="pridelovalec"  :shema="shema" :sezona="dataSezona.sezona">
          </pridelovalec>
            
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                          @datastatechange="dataStateChange"
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                  <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>

                    <template v-slot:shranigumb="{props}">
                      <button
                             :disabled="editDisabled"
                                title="Shrani kulture"
                                class="k-button k-primary"
                                @click="shraniKulture(props.dataItem)"
                            >
                                Shrani
                            </button>
                    </template>
                   <template v-slot:certifikatLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="'/javno/certifikatpdf/'+props.dataItem._id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="certificate"/> &nbsp;
                         
                    </a>
                </td>
                    </template>
                   
                    <template v-slot:certifikatPDFLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="apiUrl+'/certifikati/print/?url='+baseUrl+'/javno/certifikatpdf/'+props.dataItem._id+'&ime='+props.dataItem.stevilkacertifikata" target="_blank" title="Poglej">
                         <font-awesome-icon icon="file-pdf"/>&nbsp;
                         
                    </a>
                    &nbsp;
                    <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="apiUrl+'/certifikati/print/?url='+baseUrl+'/javno/certifikatpdf/'+props.dataItem._id+'?lang=en&ime='+props.dataItem.stevilkacertifikata" target="_blank" title="Poglej">
                         <font-awesome-icon icon="file-pdf"/> (en)
                         
                    </a>
                </td>
                    </template>

                     <template v-slot:certifikatPDFAngLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="'/javno/certifikatpdfang/'+props.dataItem._id" target="_blank" title="Poglej angleško">
                         <font-awesome-icon icon="file-pdf"/>
                         
                    </a>
                </td>
                    </template>


                    

                 <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                           <!--
                           <button
                                title="Omogoči urejanje"
                                class="k-button k-primary"
                               
                            >
                                Omogoči urejanje
                            </button>
                          -->
                        <button :disabled="editDisabled"
                                title="Dodaj"
                                class="k-button k-primary"
                                @click="insert">
                                Dodaj certifikat
                        </button>
          <!-- 
                        <button :disabled="editDisabled"
                                title="Izvozi vse certificirano"
                                class="k-button k-primary"
                                @click="izvozi">
                                Izvozi vso certificirano pridelavo
                        </button>

                        <button :disabled="editDisabled"
                                title="Obrazec certificiranje"
                                class="k-button k-primary"
                                @click="certificiranje">
                                Obrazec certificiranje
                        </button>
                      -->
                        <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                           <!-- 
                             <button
                             :disabled="editDisabled"
                                title="Shrani kulture"
                                class="k-button k-primary"
                                @click="shraniKulture"
                            >
                                Shrani
                            </button>
                                 
                            
                            
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        <button
                                title="Obrazec za površine"
                                class="k-button k-primary"
                                @click="kontrolniList"
                            >
                                Obrazec za površine
                            </button>
                          -->
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import '@progress/kendo-ui' // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.treelist' // Imports only the TreeList script and its dependencies

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
//import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
import sifrantKulture from './support/kulture-data';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import SifrantKulturDownCell from './support/SifrantKulturDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
//import { sifrantService } from '../services';


//import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
//import numbers from 'cldr-numbers-full/main/es/numbers.json';
//load(
    //likelySubtags,
    //numbers);

import { process } from '@progress/kendo-data-query';
import moment from 'moment'




//Vue.component('Grid', Grid);
//Vue.component('toolbar', GridToolbar);

//var kulture=[{id:1,kulturaid:1,naziv:"A",povrsina:"1",kolicina:"2",enota:"kg",datumdolocitvestatusa:new Date(),datumveljavnostistatusa:null,status:""},
             //{id:2,kulturaid:1,naziv:"B",povrsina:"2",kolicina:"3",enota:"kg",datumdolocitvestatusa:null,datumveljavnostistatusa:null,status:""}
              //];
              var kulture=[];

const CommandCell = Vue.component("template-component", {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sezona: Number,

    },
    computed: {
        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
    /*
     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziGerke"  title="Gerki">
                         <font-awesome-icon icon="layer-group"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKulture" title="Kulture">
                         <font-awesome-icon icon="seedling"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediZivali" title="Živali">
                         <font-awesome-icon icon="horse-head"/>
                    </button>
                     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediProizvode" title="Proizvodi">
                         <font-awesome-icon icon="cheese"/>
                    </button>
    */     
    },
    template: ` <td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        @click="prikaziCertifikat" title="Uredi">
                         <font-awesome-icon icon="certificate"/>
                         
                    </button>
                     
                    </div>
                </td>
                `,
    computed:{
        editDisabled(){
          return this.dataItem._id?false:true;
        },
    },
    methods: {
        prikaziCertifikat: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'certifikatJavno', params: { certifikatid:this.dataItem._id } })
            
        },
      
      
    }
});



export default {
  components:{
        'ukaznigumbiknt': StatusCommandCell,
      'dropdownlist': DropDownList,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
       'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid','shema'],
    data () {
        return {
            //defaultItemSezona: { sezona: 'Izberi sezono...'},
            sifrantTree:{},
            dataLoading:false,
            apiUrl:Vue.prototype.$config.apiUrl,
            dataSezona:this.sezona,
            baseUrl:window.location.origin,
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
            //    { field: "ime", title:"Ime",editable:false,width: "150px"},
                //{ field: "kmgmid", title:"KMG-MID",editable:false,width: "150px"},
                //{ field: "naslov", title:"Naslov",editable:false,width: "250px"},

                //{ field: "postnastevilka", title:"Pošta",editable:false,width: "130px"},
                //iz idja naložit šifro
                { field: "stevilkacertifikata", title:"Številka",width: "170px"},
                { field: "datumizdaje", title:"Datum izdaje", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "datumveljavnosti", title:"Datum veljavnosti", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "stariCertifikat", title:"Zamenjuje certifikat št.:",width: "150px"},
                { field: "informacije", title:"Informacije",width: "170px"},
                { field: "veljaven", title:"Veljaven", editor: 'boolean',width: "70px", cell:this.veljavenIcon,validation: { required: true}},
                { title: "Poglej certifikat", cell: 'certifikatLink',filterable:false,columnMenu: null,width:"200px",sortable:false},
                //{ title: "Natisni certifikat", cell: 'certifikatPDFLink',filterable:false,columnMenu: null,width:"130px",sortable:false},
                
               { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
               { cell: 'shranigumb', width: '80px', hidden:this.editDisabled },
              
              
                //  { field: "status", title:"Status", cell:StatusCell},
                //gerk view link http://rkg.gov.si/GERK/WebViewer/#query=GERK_SDO:GERK_PID:4605424
                //kmg view
                //http://rkg.gov.si/GERK/WebViewer/#KMG=100735069
                //{ field: 'stanje', title: '', cell: this.cellFunction },
               // { field: "statuspridelovalca", title:"Status",editable:false,width: "200px"},
                //{ field: "kontrolnaorganizacija", title:"V kontroli pri",editable:false,width: "200px"},
                //{ field: "jeaktivna", title:"Aktivna",editable:false,filter:'boolean',width: "100px"},
                
                
                //{ field: "pisanje", title:"Dovoli pisanje",editor: 'boolean',filter:'boolean',width: "150px" },
                //{ cell: CommandCell, width: '180px',filterable:false }
            ],
          

           

        }
    },
      computed: {

        //...mapState('sifrant', ['sifrant']),
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },
        ...mapState({gridData(state) {
         // console.log(state.kultura);
         //make editable?
          return state.certifikat.certifikat;
        }}),
        ...mapState({zadnjastevilka(state) {
         // console.log(state.kultura);
         //make editable?
          return state.certifikat.zadnjastevilka;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

      //potegni šifrant iz sifrantstore
     /* var groupedAreas = [];
dataItems.map(function(d) {
  if(groupedAreas.filter(function(item, i) {
   return item.areaName === d.AreaName; 
  }).length === 0) {
    groupedAreas.push({ areaName: d.AreaName, subsidiaries:  dataItems.filter(function(r) { return r.AreaName === d.AreaName; }) });
  }
});*/
 if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
        ...mapActions('certifikat', ['load','save','loadstcert','saveCert']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('certifikat',['update',"add","remove","makeEditable",'replace']),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        //...mapActions('sifrant', ['load']),
         veljavenIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let veljaven=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.veljaven)
                veljaven=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let veljavenWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.veljaven,"action_success":props.dataItem.veljaven}}, [veljaven]);
            return h('td', {attrs:{colspan:1}}, [veljavenWrapper]);
        },
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(!props.dataItem.jeaktivna)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
        naloziPodatke: function(){
          this.dataLoading=true;
        this.replace([]);
          this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(()=>{
        

        this.load({sezona:this.dataSezona.sezona,strankaid:this.pridelovalecid,makeEditable:!this.editDisabled,shema:this.shema}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        });
      
        },
        
        itemChange: function (e) {
            //const updatedData  = this.gridData.slice();
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          e.dataItem[e.field] = e.value;
          if(e.field=="veljaven")
            e.dataItem[e.field]=e.value?1:0;
          
         //   const item = this.update(e.dataItem);
            //item[e.field] = e.value;
            //this.repalce(updatedData);
        },
        izvozi(){
          var route=this.$router.resolve({ name: 'certificiranpridelekPDF', params: {sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec._id,shema:this.shema} });
          window.open(route.href, '_blank');
        },
        certificiranje(){
          var route=this.$router.resolve({ name: 'certificiranjePDF', params: {sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec._id,shema:this.shema} });
          window.open(route.href, '_blank');
        },

         insert() {
            this.loadstcert({sezona:this.dataSezona.sezona,shema:this.shema}).then(data=>{
                
                const dataItem = { inEdit: true,jeaktivna:true,
                datumveljavnosti:new Date(this.dataSezona.sezona*1+1,11,31),
                datumizdaje:new Date(),
                veljaven:1,
                shema:this.shema,
                strankaid:this.pridelovalecid,
                sezona:this.dataSezona.sezona,                  
                stevilkacertifikata:(this.shema=="EKO PRI"?"EKO":"PRE")+this.dataSezona.sezona.toString().substring(2,4)+(data+1)
                   };
            //const newproducts = this.gridData.slice();
            //newproducts.unshift(dataItem);
            this.add(dataItem);

            })
           
          //  this.repalce(newproducts);
        },
        edit: function (e) {
          //console.log(e);
            console.log(e.dataItem)
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = true;
            
            this.update(e.dataItem);
            console.log(this.kultura);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
                dataItem[value]=dataItem.oldValues[value];
            }
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
          console.log(e.dataItem);
          for (const value in e.dataItem.newValues){
            e.dataItem[value]=e.dataItem.newValues[value];
          }
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = true;
          //  const data = this.gridData.slice();
            this.update(e.dataItem);
            //e.dataItem.id = this.update(kulture, e.dataItem).id;
        },
        removeItem(e) {

            if (e.dataItem.inEdit)
                e.dataItem.jeaktivna = false;
            else
                e.dataItem.jeaktivna = true;  
            e.dataItem.inEdit =!e.dataItem.inEdit;
            //this.update(this.gridData, e.dataItem, true);
              
            this.update(e.dataItem);

            //this.remove(e.dataItem);
            //console.log(this.gridData);
            //this.replace(this.gridData.slice());
        },
     nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota površin: ' + this.kulture.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)+ ' ha']);
        },
     nogaVsotaKolicin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota količin: ' + this.gerk.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)]);
        },
    

       sezonaChange(event) {
             const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'certifikat', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id,shema:this.shema} });
             this.naloziPodatke();
             // });



        },
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.gerk, {});
           // console.log(this.dataResult);

        },
      
        shraniKulture (certifikat) {
          //  this.$router.go(-1);
          console.log("Shranjujem!!");
          console.log(certifikat);
        

              this.saveCert({certifikat:certifikat});
      //         this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
       
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
        //do doli
        
    }
};
</script>

